<template>
  <div class="page">
    <div class="content">
      <picture class="hero">
        <source
          srcset="@/assets/images/mobile/bg.webp"
          type="image/webp"
        />
        <img
          src="@/assets/images/mobile/bg.jpg"
          width="750"
          height="872"
          fetchpriority="high"
          alt=""
        />
      </picture>
      <img
        class="content-img"
        :src="Content"
        width="194"
        height="188"
        alt=""
      />
      <div class="btn-group">
        <button
          type="button"
          class="download-button"
          :disabled="downloading"
          @click="$emit('download')"
        >
          {{ storeReady ? '前往應用商店' : '立即下載' }}
        </button>
      </div>
      <img
        class="bg2-img"
        :src="bg2"
        width="750"
        height="3574"
        loading="lazy"
        decoding="async"
        alt=""
      />
      <div class="bottom-dl">
        <img
          class="bg3-img"
          :src="bg3"
          width="750"
          height="1568"
          loading="lazy"
          decoding="async"
          alt=""
        />
        <button
          type="button"
          class="btn"
          :disabled="downloading"
          @click="$emit('download')"
        >
          <span
            v-if="storeReady"
            class="store-label"
          >
            前往應用商店
          </span>
          <picture v-else>
            <source
              srcset="@/assets/images/mobile/btn.webp"
              type="image/webp"
            />
            <img
              :src="btn"
              width="686"
              height="104"
              loading="lazy"
              decoding="async"
              alt="立即下載"
            />
          </picture>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import Content from '@/assets/images/mobile/content.png';
import bg2 from '@/assets/images/mobile/bg2.jpg';
import bg3 from '@/assets/images/mobile/bg3.jpg';
import btn from '@/assets/images/mobile/btn.png';

defineProps({ downloading: Boolean, storeReady: Boolean });
defineEmits(['download']);
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';

.page {
  width: 100%;
  max-width: $mobile-max-width;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .content {
    position: relative;
    background: #ffffff;
    padding: 1.4rem 0 0;

    .hero {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      pointer-events: none;

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    > :not(.hero) {
      position: relative;
    }

    .content-img {
      display: block;
      margin: 0 auto 2.7rem;
      width: 1.94rem;
      height: 1.88rem;
      object-fit: contain;
    }

    .btn-group {
      margin: 0 auto 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .download-button {
      width: 4rem;
      height: 0.8rem;
      padding: 0;
      border-radius: 0.12rem;
      background: linear-gradient(to bottom, #ffe7a8, #fff5d7);
      border: 1px solid #ffe7aa;
      font-size: 0.28rem;
      color: #1a1208;
      cursor: pointer;
    }

    .bg2-img,
    .bg3-img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .bottom-dl {
    position: relative;

    .btn {
      position: absolute;
      left: 50%;
      bottom: 1rem;
      transform: translateX(-50%);
      width: 6.86rem;
      height: 1.04rem;
      padding: 0;
      border: 0;
      background: none;
      cursor: pointer;

      .store-label {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border-radius: 0.12rem;
        background: linear-gradient(to bottom, #ffe7a8, #fff5d7);
        font-size: 0.32rem;
        color: #1a1208;
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
